import { createContext, useContext, useEffect, useState } from "react";
import { authMe, authLogin, authRegister, authLogout } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = signed out
  const [authModal, setAuthModal] = useState(null); // "login" | "signup" | null

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback exchanges the session_id and establishes the session first.
    if (window.location.hash?.includes("session_id=")) {
      setUser(false);
      return;
    }
    authMe().then(setUser).catch(() => setUser(false));
  }, []);

  const login = async (payload) => {
    const u = await authLogin(payload);
    setUser(u);
    return u;
  };

  const signup = async (payload) => {
    const u = await authRegister(payload);
    setUser(u);
    return u;
  };

  const logout = async () => {
    await authLogout().catch(() => {});
    setUser(false);
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/profile";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        authModal,
        openAuth: setAuthModal,
        closeAuth: () => setAuthModal(null),
        login,
        signup,
        logout,
        googleLogin,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
